<template>
  <el-row type="flex" class="todo-provider">
    <el-col>
      <div class="todo-provider-service-type">
        Tipo de servicio: {{ user.profile && user.profile.service_type ? user.profile.service_type.name : '' }}
      </div>
      <div class="todo-provider-name">
        Nombre: {{ user && user.profile ? user.profile.name : ' ' }}
      </div>
      <div class="todo-provider-email">
        <b>Email:</b> {{ user.email? user.email : '-' }}
      </div>
      <div class="todo-provider-email">
        <b>Bio:</b> {{ user.bio? user.bio : '-' }}
      </div>
      <div class="todo-provider-email">
        <b>Direccion:</b> {{ user.address? user.address : '-' }}
      </div>
      <div class="todo-provider-email">
        <b>Número:</b> {{ user.phone? user.phone : '-' }}
      </div>
      <div class="todo-provider-email">
        <b>Cedula:</b> {{ user.cedula? user.cedula : '-' }}
      </div>
    </el-col>
    <el-col class="text-right">
      <el-row type="flex" class="row-bg" justify="end">
        <div class="edit-button">
          <el-button type="danger"  v-if="!user.isHidden" v-on:click="hide(user)">Ocultar</el-button>
          <el-button type="success" v-if="user.isHidden" v-on:click="hide(user)">Mostrar</el-button>
        </div>
      </el-row>
      <div class="todo-provider-date">
        Creado: {{ user.created_at ? user.created_at : ' ' }}
      </div>
      <div class="todo-provider-views">
        {{ $t('views') }}:
        <span>{{ user.profile ? user.profile.visits_count : ' ' }}</span>
      </div>
      <div class="todo-provider-rating">
        <span>{{ user.profile ? user.profile.average_rating : ' ' }}</span>
        <svg-icon name="star" class="selected" />
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import { hide } from '@/api/users'
  export default {
    props: {
      user: Object
    },
    methods: {
      hide: async function(msg) {
        const result = await hide(msg.id, !msg.isHidden)
        this.user.isHidden = result.data[0].isHidden
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/variables';

  .todo-provider {

    .todo-provider-service-type {
      color: $color-text-secondary;
    }

    .todo-provider-name {
      font-weight: bold;
      font-size: 18px;
      line-height: 34px;
      color: $color-text-regular;
    }

    .todo-provider-email {
      /* */
    }

    .edit-button{
      //width: 40px;
    }
    .todo-provider-date {
      font-size: 13px;
      color: $color-text-secondary;
    }

    .todo-provider-views {
      font-size: 13px;
      color: $color-text-secondary;

      span {
        font-weight: 600;
        font-size: 14px;
      }
    }

    .todo-provider-rating {
      font-weight: 500;
      font-size: 15px;
      line-height: 26px;
      color: $color-text-regular;

      .svg-icon {
        fill: $color-warning;
        color: $color-warning;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        margin-left: 3px;
      }
    }
  }
</style>
